import { clsx } from 'clsx';
import { Box } from '@material-ui/core';

import useStyles from './CustomAddButton.styles';

export function CustomAddButton({ disabled, onClick, classes = {} }) {
  const _classes = useStyles({ disabled });
  return (
    <Box
      aria-label='Add'
      className={clsx(_classes?.button, classes?.button)}
      disabled={disabled}
      onClick={disabled ? null : onClick}
    >
      <span className={clsx(_classes.icon, classes?.icon)}>+</span>
    </Box>
  );
}
